module.exports = __webpack_public_path__ + "static/Montserrat-Black-27e3649bab7c62fa21b8837c4842e40e.ttf";